/* eslint-disable import/no-extraneous-dependencies */
import { Project } from '@leverege/api-redux'
import { LoginScreen as MoltenLoginScreen } from '@leverege/molten/screens'
import { GlobalState } from '@leverege/ui-redux'
import QS from 'query-string'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

export default function LoginScreen( props ) {
  const [ error, setError ] = useState( '' )
  const [ useMoltenLoginScreen, setUseMoltenLoginScreen ] = useState( false )

  const { pathname, search, query } = useLocation()
  const queryError = query?.error

  const oidcClients = Object.values(
    useSelector( state => Project( window.Molten.getConfig( 'api/projectId' ) )
      .oidcClients()
      .getOidcClients( state ),
    ) ?? {},
  )

  useEffect( () => {
    if ( !pathname.includes( 'embedFactoryCycleTimeMonitoring' ) ) {
      setUseMoltenLoginScreen( true )
      return
    }

    if ( !oidcClients.length ) {
      setUseMoltenLoginScreen( true )
      return
    }

    const oktaOidcClient = oidcClients.find( c => c.alias === 'tpi-okta' )

    if ( !oktaOidcClient ) {
      setError( 'Okta OIDC client is not set up properly' )
      return
    }

    if ( queryError ) {
      setError( `Oops, something went wrong when logging in with ${queryError}` )
      return
    }

    if ( query.token ) {
      GlobalState.dispatch( ( dispatch, getState, { api } ) => {
        
        api.setToken( query.token )

        const url = QS.exclude( window.location.origin + pathname + search, [ 'token' ] )

        window.location = url
      } )
      return
    }

    GlobalState.dispatch( ( dispatch, getState, { api } ) => {
      const callbackUrl = window.location.origin + pathname + search

      const oktaLoginUrl = api.oidcLoginUrl(
        oktaOidcClient,
        `${callbackUrl}`,
        `${callbackUrl}&error=${oktaOidcClient.name}`,
      )

      window.location = oktaLoginUrl
    } )
  }, [ oidcClients, pathname, queryError, search, query ] )

  if ( error ) return error

  if ( useMoltenLoginScreen ) return <MoltenLoginScreen {...props} />

  return 'Loading...'
}
